import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {
  getFlattenedClausesFromNestedConditions,
  getConditionsFriendlyDescription
} from "@appcues/libcues";

export default class HumanReadableCriteria extends React.Component {
  static propTypes = {
    conditions: PropTypes.object,
    steps: PropTypes.object.isRequired,
    segments: PropTypes.object.isRequired
  };

  static defaultProps = {
    conditions: {}
  };

  humanReadableClauses() {
    const clauses =
      this.props.clauses ||
      getFlattenedClausesFromNestedConditions(this.props.conditions);
    const { steps, segments } = this.props;
    if (clauses && segments && steps) {
      return {
        __html: getConditionsFriendlyDescription(null, clauses, steps, segments)
      };
    }
    return { __html: "" };
  }

  render() {
    return (
      <CriteriaClauses dangerouslySetInnerHTML={this.humanReadableClauses()} />
    );
  }
}

const CriteriaClauses = styled.div`
  line-height: 1.5em;
  border-left: 4px solid ${props => props.theme["$gray-2"]};

  .group {
    display: block;
    padding-left: 1.5em;
  }

  .condition {
    display: block;
  }

  .logic {
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 800;
    font-size: 0.675em;
    color: ${props => props.theme["$gray-5"]};
    position: relative;
    top: 3px;
  }
  .logic.and {
    color: ${props => props.theme["$cutecumber"]};
  }
  .logic.or {
    color: ${props => props.theme["$yellow-dark"]};
  }
`;
